import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import loadScript from 'lib/loadScript';

/**
 * @param {object} props
 * @param {string} [props.html]
 * @param {string} [props.stylesheetUrl]
 * @param {string} [props.scriptUrl]
 */
export function ArticleTextToSpeechAudioPlayer({
  html,
  stylesheetUrl,
  scriptUrl,
}) {
  const loadArticlePlayer = html && stylesheetUrl && scriptUrl;

  useEffect(() => {
    if (!loadArticlePlayer) return;

    loadScript(scriptUrl, { attributes: { type: 'module' } });
  }, [scriptUrl, loadArticlePlayer]);

  if (!loadArticlePlayer) return null;

  return (
    <div id="nbc-news-article-audio" data-testid="article-audio-player">
      <div className="sentinel absolute bg-none" />
      <link data-testid="article-audio-stylesheet" href={stylesheetUrl} rel="stylesheet" type="text/css" />
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}

ArticleTextToSpeechAudioPlayer.propTypes = {
  html: PropTypes.string,
  stylesheetUrl: PropTypes.string,
  scriptUrl: PropTypes.string,
};
